/* global globals */
/* eslint no-underscore-dangle: ['error', { allow: [
  _verificationStatus, _exampleImage, _capturedImage, _loading,
  _error, _disabled, _needActivate, _needImage, _forceRetake, _adminComment, _isSimulated
] }] */
import { EventEmitter } from 'events';
import assign from 'object-assign';
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

let _verificationStatus = '';
let _exampleImage = '';
let _capturedImage = '';
let _loading = false;
let _error = '';
let _disabled = false;
let _needActivate = false;
let _needImage = false;
let _forceRetake = false;
let _adminComment = '';
let _isSimulated = false;

const VerificationStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  setVerificationStatus(status) {
    _verificationStatus = status;
  },

  getVerificationStatus() {
    return _verificationStatus;
  },

  setExampleImage(gender) {
    _exampleImage = `${get(globals, 'staticImageUri', '/')}verification/ver_${gender}.jpg`;
  },

  getExampleImage() {
    return _exampleImage;
  },

  setCapturedImage(image, isFilename) {
    if (!image) {
      _capturedImage = image;
      return;
    }

    _capturedImage = isFilename ? `${get(globals, 'gcloudUri', '/')}v/${image}` : image;
  },

  getCapturedImage() {
    return _capturedImage;
  },

  setLoading(value) {
    _loading = value;
  },

  getLoading() {
    return _loading;
  },

  setError(msg) {
    _error = msg;
  },

  getError() {
    return _error;
  },

  setDisabled(status) {
    _disabled = !['active', 'muted', 'unverified', 'simulated'].includes(status);
  },

  getDisabled() {
    return _disabled;
  },

  setNeedActivate(status) {
    _needActivate = status === 'unverified';
  },

  getNeedActivate() {
    return _needActivate;
  },

  setAdminComment(comment) {
    _adminComment = comment;
  },

  getAdminComment() {
    return _adminComment;
  },

  setIsSimulated(simulated) {
    _isSimulated = simulated;
  },

  getIsSimulated() {
    return _isSimulated;
  },

  setNeedImage(image) {
    _needImage = !image;
  },

  getNeedImage() {
    return _needImage;
  },

  setForceRetake(value) {
    _forceRetake = value;
  },

  getForceRetake() {
    return _forceRetake;
  },

  getRestricted() {
    return (_disabled || _needActivate || _needImage);
  },
});

VerificationStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.VERIFICATION_IMAGE_SUBMIT_SUCCESS: {
      if (action.filename) {
        VerificationStore.setVerificationStatus('pending');
        VerificationStore.setCapturedImage(action.filename, true);
      }
      VerificationStore.setLoading(false);
      VerificationStore.emitChange();
      break;
    }
    case ActionTypes.VERIFICATION_IMAGE_SUBMIT_ERROR: {
      if (action.myStatus !== undefined) {
        VerificationStore.setDisabled(action.myStatus);
        VerificationStore.setNeedActivate(action.myStatus);
      }

      if (action.myImage !== undefined) {
        VerificationStore.setNeedImage(action.myImage);
      }

      VerificationStore.setError(action.msg || 'txt: Nezināma kļūda');
      VerificationStore.setForceRetake(action.retake || false);
      VerificationStore.setLoading(false);
      VerificationStore.emitChange();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = VerificationStore;
